(function() {
    'use strict';
    var AuditPackSendToClientCtrl = function($scope, ajaxCall, xmsNotificationFactory) {
        $scope.expectedResultTime = 2;
        $scope.ajaxInProgress = false;

        $scope.confirm = function(ajaxUrl) {
            $scope.ajaxInProgress = true;
            //It's doing a POST
            ajaxCall.getData(ajaxUrl, {}).then(
                function(result) {
                    console.log(result);
                    $scope.ok();
                    $scope.ajaxInProgress = false;
                    xmsNotificationFactory.addObj({
                        id: "AuditPackSendToClientConfirm",
                        type: result.data.type,
                        bodyHtml: result.data.bodyHtml,
                        timeout:10
                    });
                },
                function(result) {
                    console.error('AuditPackSendToClientCtrl','An unexpected error has occurred',result);
                    $scope.ok();
                    $scope.ajaxInProgress = false;
                    xmsNotificationFactory.addObj({
                        id: "GenericError",
                        type: 'danger',
                        bodyHtml: 'An unexpected error has occurred',
                        timeout:10
                    });
                });
        };
    };
    AuditPackSendToClientCtrl.$inject = ['$scope', 'ajaxCall', 'xmsNotificationFactory'];
    angular.module('app').controller('AuditPackSendToClientCtrl', AuditPackSendToClientCtrl);
}());
